// Font definitions for header/display text
// These fonts apply to headings on public-facing pages

export interface HeaderFont {
  id: string;
  name: string;
  family: string;
  googleFontsUrl: string;
}

export const headerFonts: HeaderFont[] = [
  {
    id: 'playfair-display',
    name: 'Playfair Display',
    family: "'Playfair Display', Georgia, serif",
    googleFontsUrl: 'https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&display=swap',
  },
  {
    id: 'lora',
    name: 'Lora',
    family: "'Lora', Georgia, serif",
    googleFontsUrl: 'https://fonts.googleapis.com/css2?family=Lora:wght@400;500;600;700&display=swap',
  },
  {
    id: 'cormorant-garamond',
    name: 'Cormorant Garamond',
    family: "'Cormorant Garamond', Georgia, serif",
    googleFontsUrl: 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&display=swap',
  },
  {
    id: 'montserrat',
    name: 'Montserrat',
    family: "'Montserrat', system-ui, sans-serif",
    googleFontsUrl: 'https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap',
  },
  {
    id: 'libre-baskerville',
    name: 'Libre Baskerville',
    family: "'Libre Baskerville', Georgia, serif",
    googleFontsUrl: 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&display=swap',
  },
  {
    id: 'cinzel',
    name: 'Cinzel',
    family: "'Cinzel', Georgia, serif",
    googleFontsUrl: 'https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700&display=swap',
  },
];

export function getHeaderFont(fontId: string): HeaderFont {
  return headerFonts.find(f => f.id === fontId) || headerFonts[0];
}
